import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import * as jobActions from '../jobActions';import * as statsActions from '../statsActions';import * as contractorActions from '../contractorActions';
import * as employeeActions from '../employeeActions';
import enums from '../enum';
import globalRelay from '../globalRelay';
import util from '../util';
import componentServices from '../componentServices';

import { ContextMenu, Expander, JobSearchResults, Popup, SalesPerformanceChart, sortableComponent, Spinner } from './sharedComponents';
import NewJobWorkflow from './newJobWorkflow';
import JobSearchForm from './jobSearchForm';

import SalesGoalEntryModal from './salesGoalEntryModal';
import { getCollection, getModel, ModelCollection } from '../store';

function getBuckets () {
	return [{
		label: 'Rejected',
		className: 'rejected',
		test: jobCosts => jobCosts.some(jc => jc.currentStatus === 'rejected')
	}, {
		label: 'Lead',
		test: jobCosts => !jobCosts.count()
	}, {
		label: 'Prospect',
		test: jobCosts => !!jobCosts.count() && !jobCosts.some(jc => jc.type === 'contract')
	},{
		label: 'Open Change Orders',
		test: jobCosts => jobCosts.some(jc => jc.type === 'contract' && _.filter(jc.changeOrders,co => !co.isClosed).length)
	}, {
		label: 'Client',
		test: jobCosts => jobCosts.some(jc => jc.type === 'contract') && !jobCosts.some(jc=>_.filter(jc.changeOrders,co => !co.isClosed).length)
	}];
}

function getProfileSortItem (businessSegment) {
	return businessSegment === enums.businessSegments.Retail ? 'retailJobsSortKey' : 'builderJobsSortKey';
}

const JobTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<JobTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<JobTableBody list={list} {...childProps} />
		</table>
	);
});

class JobTableHeader extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();

		const sortItem = getProfileSortItem(this.props.businessSegment);
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();
		const preferredSortKey = currentEmployee.getProfileValue(sortItem, '');

		this.props.updateSort(path);

		if (path !== preferredSortKey) {
			employeeActions.setProfileValue({ name: sortItem, value: path });
		}
	}
	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}
	render () {
		return (
			<thead>
				<tr>
					<td />
					<td className={'jobNumber' + ' ' + this.getClassName('relayId')} onClick={this.handleClick.bind(this, 'relayId')}>Relay No.</td>
					<td className={'name' + ' ' + this.getClassName('primaryClientContactName')} onClick={this.handleClick.bind(this, 'primaryClientContactName')}>Client</td>
					<td className={'address' + ' ' + this.getClassName('workSiteAddress/street')} onClick={this.handleClick.bind(this, 'workSiteAddress/street')}>Address</td>
					<td className={'name' + ' ' + this.getClassName('builder/name')} onClick={this.handleClick.bind(this, 'builder/name')}>Builder</td>
					<td className={'date' + ' ' + this.getClassName('dateModifiedOrCreated')} onClick={this.handleClick.bind(this, 'dateModifiedOrCreated')}>Last Updated</td>
					<td />
				</tr>
			</thead>
		);
	}
}

const JobTableBody = ({ list, ...childProps }) => {
	const { store } = componentServices;
	const rows:JSX.Element[] = [];

	list.forEach((job) => {
		rows.push(<JobTableRow job={job} key={job.key} builder={ getModel({ store, collection: ModelCollection.contractors, key: job.builderKey }) } {...childProps} />);
	});

	return (
		<tbody>
			{rows}
		</tbody>
	);
};

class JobTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}
	handleClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.pushPathSegments(this.props.job.key));
	}
	render () {
		const { job, builder } = this.props;
		const primaryContactName = job.primaryClientContactName || 'N/A';
		const address = (job.workSiteAddress && job.workSiteAddress.street) || 'N/A';
		const relayNumber = job.relayNumber || 'N/A';
		const builderName = (builder && builder.name) || 'N/A';

		return (
			<tr onClick={ this.handleClick }>
				<td />
				<td>{ relayNumber }</td>
				<td>{ primaryContactName }</td>
				<td>{ address }</td>
				<td>{ builderName }</td>
				<td>{ util.dateHelper.formatDate(job.dateModifiedOrCreated, { userFriendly: true }) }</td>
				<td />
			</tr>
		);
	}
}

export default class SalesJobs extends React.PureComponent<any,any> {
	private _fetchedContractorKeys;

	constructor (props) {
		super(props);

		this.handlePerformanceContextMenuClick = this.handlePerformanceContextMenuClick.bind(this);
		this.togglePerformance = this.togglePerformance.bind(this);
		this.handleAddJobClick = this.handleAddJobClick.bind(this);
		this.state = this.getStateFromProps(props);
	}

	componentDidMount () {
		const { performanceExpanded, targetEmployee } = this.state;

		if(targetEmployee) {
			jobActions.fetchActiveJobs({ userId: targetEmployee.user.key });
		}

		actions.setHeaderAction({
			key: 'job-add-action-builder',
			element: <button className="icon addPerson" onClick={this.handleAddJobClick}><span /></button>
		});

		if (performanceExpanded) {
			this.loadJobStats();
		}
	}

	componentWillUnmount () {
		actions.deleteHeaderAction({ key: 'job-add-action-builder' });
	}

	UNSAFE_componentWillReceiveProps (props) {
		this.setState(this.getStateFromProps(props));
	}

	getStateFromProps (props) {
		const { securityContext, store } = componentServices;
		const state = _.assign({}, this.state);
		const routeState = store.getIn(['viewState', 'routeState']);
		const currentEmployee = securityContext.getCurrentEmployee();
		const targetEmployee = routeState && routeState.employeeKey ? getModel({ store, collection: ModelCollection.employees, key: routeState.employeeKey }) : currentEmployee;
		const globalConfig = globalRelay.config!;
		const roleTitleTests = globalConfig.systemRoleEmployeeTitleTests;
		const roleTests = props.businessSegment === enums.businessSegments.Retail ? roleTitleTests.designer : roleTitleTests.accountManager;

		state.isSalesperson = !!targetEmployee && _.reduce(roleTests, (r, v) => {
			if (!r) {
				const test = new RegExp(v, 'i');
				r = test.test(targetEmployee.orgTitleKey);
			}
			return r;
		}, false);

		state.isPerformanceManager = securityContext.currentUserHasFeature('builder-sales', 'manage-sales-performance');

		if (!this.state || this.state.targetEmployee !== targetEmployee) {
			state.performanceExpanded = targetEmployee && currentEmployee.key !== targetEmployee.key && state.isPerformanceManager;
		}

		state.targetEmployee = targetEmployee;

		return state;
	}

	loadJobStats () {
		const jobStats = componentServices.store.getIn(['viewState', 'searchResults', 'jobStats']);

		if (!jobStats || (jobStats.timestamp + (1000 * 60 * 5)) < Date.now()) {
			statsActions.fetchFiscalYears()
				.then(() => {
					const currentModule = componentServices.store.getIn(['viewState', 'currentModule']);
					const businessSegment = (currentModule === 'retail-sales' ? enums.businessSegments.Retail : currentModule === 'builder-sales' ? enums.businessSegments.Builder : enums.businessSegments.Unknown);
					const now = new Date();
					const fiscalYear = getCollection({ collection: ModelCollection.fiscalYears}).find(fy => fy.startDate <= now && fy.endDate > now);
					jobActions.fetchJobsForFYSalesStats({ businessSegment, fiscalYear });
				});
		}
	}

	togglePerformance () {
		const { performanceExpanded } = this.state;

		if (!performanceExpanded) {
			this.loadJobStats();
		}

		this.setState({ performanceExpanded: !performanceExpanded });
	}

	handleAddJobClick (e) {
		e.preventDefault();
		const { businessSegment } = this.props;

		actions.pushModal({
			component: (<NewJobWorkflow close={ actions.popModal } initialTitle={ businessSegment === enums.businessSegments.Retail ? 'New Lead or Job' : 'New Job'} businessSegment={ businessSegment } />),
			rendersAlerts: true
		});
	}

	handlePerformanceContextMenuClick (e) {
		const { targetEmployee } = this.state;
		const jobStats = componentServices.store.getIn(['viewState', 'searchResults', 'jobStats']);
		const openSalesGoals = () => {
			actions.popModal();
			actions.pushModal({
				component: <SalesGoalEntryModal fiscalYear={ jobStats.fiscalYear.year } employeeKey={ targetEmployee.key } />
			});
		};
		const items = [{ label: 'Enter Sales Goal', action: openSalesGoals }];
		const popup = <Popup target={e.target}><ContextMenu items={ items } /></Popup>;

		actions.pushModal({ component: popup });
	}

	_fetchContractorsForJobs (list) {
		const { store } = componentServices;
		if (list) {
			const fetching = this._fetchedContractorKeys = this._fetchedContractorKeys || [];
			list.forEach(x => {
				if (x.builderKey && !getModel({ store, collection: ModelCollection.contractors, key: x.builderKey }) && fetching.indexOf(x.builderKey) === -1) {
					contractorActions.fetchContractor({ key: x.builderKey });
					fetching.push(x.builderKey);
				}
			});
		}
	}

	render () {
		const { router, securityContext, store } = componentServices;
		const { businessSegment } = this.props;
		const { isSalesperson, isPerformanceManager, performanceExpanded, targetEmployee } = this.state;

		if (!targetEmployee) {
			return null;
		}

		const searchKey = businessSegment === enums.businessSegments.Retail ? 'retail-jobs-search' : 'builder-jobs-search';
		const currentEmployee = securityContext.getCurrentEmployee();
		const preferredSortKey = currentEmployee.getProfileValue(getProfileSortItem(this.props.businessSegment), 'relayId');
		const searchResults = store.getIn(['viewState', 'searchResults', searchKey]);
		const jobList = getCollection({ store, collection: ModelCollection.jobs}).filter(j => ['lead-lost', 'estimate-lost'].indexOf(j.currentStatus) === -1 && j.businessSegment === businessSegment && (j.createdById === targetEmployee.user.key || j.accountManagerKey === targetEmployee.key || j.coordinatorKey === targetEmployee.key || j.estimatorKey === targetEmployee.key || j.processorKey === targetEmployee.key));
		const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts});
		const dashboardClasses = ['dashboard'];
		const jobStats = store.getIn(['viewState', 'searchResults', 'jobStats']);
		let listContent;
		const sumGoal = Number((jobStats && targetEmployee && targetEmployee.getProfileValue(`salesGoalFY${jobStats.fiscalYear.year}`, '0')) || '0');
		

		if (searchResults) {
			dashboardClasses.push('searchResults');

			listContent = (<JobSearchResults
				list={ searchResults.list }
				parameterName={ searchResults.searchParameter.name }
				searchText= { searchResults.searchText }
				onJobClick= { (j) => router.pushHistory(router.pushPathSegments(j.key)) } />);
		}
		else {
			// TODO: fix perfomance problem caused by churning requests
			this._fetchContractorsForJobs(jobList);

			// TODO: determine how to mix actual phases with pseudo-phases like Pinned and TenPercent
			// const statuses = ['Pinned', 'Lead', 'Estimate', 'Contract', 'Change Order', 'Deliver', 'Install', 'Renovation', 'Inspect', 'TenPercent', 'Service'];

			listContent = _.map(getBuckets(), x => {
				const sectionList = jobList.filter(v => {
					return x.test(jobCosts.filter(jc => jc.jobKey === v.key));
				});

				const sectionCount = sectionList.count();

				return (!sectionCount) ? null : (
					<Expander title={x.label} isExpanded={ !!sectionCount } classNames={ x.className ? [x.className] : [] } key={ x.label }>
						<JobTable list={sectionList} initialSortKey={ preferredSortKey } />
					</Expander>
				);
			});
		}

		// for search results append 'searchResults' to 'dashboard' class below
		return (
			<div className={ dashboardClasses.join(' ') }>

				<JobSearchForm searchKey={ searchKey } />
				{ !isSalesperson ? null
					: <Expander title="Performance" isExpanded={ performanceExpanded } toggleExpander={ this.togglePerformance }>
						{ !jobStats ? <div className="chart performanceChart"><Spinner classNames={ ['dark'] } /></div>
							: <SalesPerformanceChart sumGoal = {sumGoal} fiscalYear={ jobStats.fiscalYear } startDate={ jobStats.startDate } aggregates={ jobStats.aggregates.accountManager[targetEmployee.key] } onContextMenuClick={ isPerformanceManager ? this.handlePerformanceContextMenuClick : null} />
						}
					</Expander>
				}
				{ listContent }

			</div>
		);
	}
}